import { render, staticRenderFns } from "./TeacherList.vue?vue&type=template&id=33abc85a&scoped=true&"
import script from "./TeacherList.vue?vue&type=script&lang=ts&"
export * from "./TeacherList.vue?vue&type=script&lang=ts&"
import style0 from "./TeacherList.vue?vue&type=style&index=0&id=33abc85a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33abc85a",
  null
  
)

export default component.exports